import React, {useEffect, useState} from "react";
import BlogImagePopper from "./BlogImageLarge";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import image1 from "../../../../assets/images/blog18-1.png";
import image7 from "../../../../assets/images/blog18-7.png";
import image10 from "../../../../assets/images/blog18-10.png";
import image48 from "../../../../assets/images/blog18-48.png";
import image35 from "../../../../assets/images/blog18-35.png";
import image36 from "../../../../assets/images/blog18-36.png";
import image50 from "../../../../assets/images/blog18-50.png";
import image54 from "../../../../assets/images/blog18-54.png";
import image41 from "../../../../assets/images/blog18-41.jpeg";
import image3 from "../../../../assets/images/blog18-3.png";

const Blog17 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – May 12, 2025</h2>
      </div>
      <div className="blogContentnew">
        <div className="wrapped_top_content">
          <div className="info_sect_">
            <p
              style={{
                textAlign: "justify",
                fontFamily: "var(--header-font-family)",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "30px",
                color: "#010310",
              }}
            >
              Introduction: Buckle Up – Uncertainty may just have come off the Menu
            </p>
            <p>
              Markets have been jittery, and for good reason. A continued walk up of indices in the face of increased macro risks has seen many fearing bears reappearing at the obvious resistance
              levels. Volatility continues to slide back to 20. Hawkish Fed rhetoric, geopolitical jitters and sliding Services prints with high prices paid lead to many including powell fear
              Stagflation. The S&P 500 continues to take out resistance levels and the positive news of China tariffs sees new highs for the rally. Bears talking of downside to growth now removed and
              the pro investors are short or underweight at the top of the rally. Record levels of uncertainty in result commentaries may just be about to be replaced by upgrades!
            </p>
          </div>
          <div className="relatedImg">
            <img
              src={image1}
              alt=""
            />
            <div
              className="zoomBtn"
              onClick={() => handleLargeImg(image1)}
            >
              <button>
                <img
                  src={zoomImg}
                  alt=""
                />
              </button>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv">
              <p className="highlightedBoldText">Key Market Themes: Sentiment Shifts, Liquidity Signals & Market Positioning</p>
              <p className="highlightedText_header">Risk Appetite: Retail All-In, Pros Hesitant</p>
              <p>
                We are at a classic inflection point. Professional investors remain underweight, having missed the violent upside reversal triggered by the US-China tariff détente. Meanwhile, retail
                positioning has surged— <span className="highlightedText">"Buy the Dip" is not just alive; it’s euphoric.</span>
              </p>
              <div className="relatedImg">
                <img
                  src={image7}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image7)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p>
                This divergence between institutional caution and retail enthusiasm is critical. When private wealth clients lean in this hard, the market often finds itself overextended—even if
                fundamentals eventually catch up. Whether this is genuine conviction or a fear of missing out remains to be seen. As it is the 90day pause on US/China tariffs plus global liquidity
                suggests Risk on
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv">
              <p className="highlightedText_header">The FOMO Trade & Short Squeeze Dynamics</p>
              <p>
                The comparison to <span className="highlightedText">1996–1997</span> is gaining traction. Initially thought to be a repeat of the 1998 growth shock/mini crash narrative, price action
                now suggests we could be moving into <span className="highlightedText">an exuberant melt-up phase.</span> It also mirrors the 2018 Trump 1.0 playbook with a growth shock ultimately
                ignored and no low re-test. Shorts may have to chase the market now that the downside tail risk has been chopped off.
              </p>
              <p>
                Ed Yardeni, one of the more prominent market bulls, has reduced his <span className="highlightedText">recession probability to 35%</span> and raised his{" "}
                <span className="highlightedText">year-end SPX target above 6000.</span> That shift alone has caught strategist desks off-guard. Many had called for earnings downgrades and encouraged
                clients to wait for trough multiples around <span className="highlightedText">15x forward earnings—</span> levels that now feel increasingly out of reach.
              </p>
              <hr className="divisionLine" />
            </div>
          </div>
        </div>

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv">
              <p className="highlightedText_header">Liquidity Is Speaking Louder Than Rates</p>
              <p>
                The Fed might be on pause, but liquidity is not. The Fed SOMA account absorbed <span className="highlightedText">$38 billion in bonds last week boosting QE,</span> and the PBOC added
                liquidity. It’s not official QE, but it’s having a similar impact. A <span className="highlightedText"> short-VIX unwind</span> created a stir but couldn’t stop the vacuum higher for
                equities.
              </p>
              <div className="relatedImg">
                <img
                  src={image10}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image10)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p>
                Meanwhile, China has quietly enacted <span className="highlightedText">10 new policy measures, </span>including a cut to the{" "}
                <span className="highlightedText">7-day reverse repo rate</span> and a 50bps reduction in reserve requirements. That’s a clear signal that Chinese policymakers are easing preemptively
                before any hard data shock manifests.
              </p>
              <div className="relatedImg">
                <img
                  src={image48}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image48)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv">
              <p className="highlightedText_header">Safe Havens Softening, but Still Relevant</p>
              <p>
                Gold saw outflows for the first time in weeks, and Silver continues to underperform. That said, with deflationary pressure lurking from Chinese oversupply and geopolitical tail risks
                simmering, the <span className="highlightedText">safe haven trade isn’t dead—just subdued.</span>
              </p>
              <div className="relatedImg">
                <img
                  src={image35}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image35)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv">
              <p className="highlightedText_header">Positioning Risk: The Pain Trade Is Higher</p>
              <p>
                The biggest tell of the week? The <span className="highlightedText">short base is thinning.</span> Tactical shorts got blown out on the gap-up after the US-China reprieve. Now the same
                desks that warned about valuation excess are scrambling to re-enter the market at higher prices.
              </p>
              <p>
                When the pain trade is up, <span className="highlightedText"> underperformance becomes its own risk.</span> If key macro deals (EU, China) materialize, there’s scope for further
                chases—especially in semis, tech, and AI leadership sectors.
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv">
              <p className="highlightedText_header">Sector Rotation: Chips, Tech, and Cyclicals</p>
              <p>
                Semiconductors (SMH) and XLK have led the rally—and for good reason. With Trump's team signaling <span className="highlightedText"> a rollback of Biden’s Chips Act restrictions,</span>
                regulatory clouds are lifting. The market likes that.
              </p>
              <div className="relatedImg">
                <img
                  src={image36}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image36)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p>
                Also, the Chips Act has quietly flipped from an earnings drag to a sentiment tailwind. Combined with strong seasonals and improving guidance, the tech leadership remains structurally
                intact—for now.
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv">
              <p className="highlightedText_header">Yield Curve & Dollar Moves: A Quiet Warning?</p>
              <p>
                The <span className="highlightedText"> US 30Y yield is pushing toward 5%, </span>
                and yet equities remain unfazed. That divergence won’t last forever. If bond yields break higher, expect risk assets to reassess quickly, unless it is genuine growth with moderate
                inflation.
              </p>

              <p>
                At the same time, the <span className="highlightedText"> DXY has broken its 20-day moving average,</span> forming an inverse H&S pattern that signals more dollar strength
                ahead—particularly if Europe and China data undershoot.
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap ">
              <div className="listImgWrapper">
                <p className="highlightedBoldText">Last Week’s Recap: What Moved the Needle</p>
                <ul className="pointersSection">
                  <li className="themesPointer fd_colm">
                    <p>
                      <span className="highlightedText">FOMC Shock:</span> Powell further removed the Fed PUT focused on STAGFLATION and June fell off the rate cut list.
                    </p>
                  </li>

                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">UK trade deals:</span> quickly followed India deal with the US one. Already a trade surplus for the US but Trump used as an example for good
                      behaviours
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">USD Trade:</span> showed mega front-loading imports
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">China PBOC:</span> rate cuts part of 10 Monetary policy boosts
                    </p>
                  </li>

                  <li className="themesPointer ">
                    <p>
                      <span className="highlightedText">Earnings: </span> Tech showed cracks at ARM, SMCR and Marvell on China market concerns. Is the market topping fears surfaced
                    </p>
                  </li>
                  <li className="themesPointer ">
                    <p>
                      <span className="highlightedText">US Chips Act:</span> Trump looking to ditch Biden’s dud and light the fireworks
                    </p>
                  </li>
                  <li className="themesPointer ">
                    <p>
                      <span className="highlightedText">Geopolitics:</span> South Asian tensions flared with India and Pakistan squabbling. Initially underpinned gold but it saw its first weekly
                      outflow.
                    </p>
                  </li>
                </ul>
              </div>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image50}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image50)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image54}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image54)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap ">
              <div className="listImgWrapper">
                <p className="highlightedBoldText">The Week Ahead: Buckle Up for Event Risk</p>
                <p>Must-Watch Events:</p>
                <ul className="pointersSection">
                  <li className="themesPointer fd_colm">
                    <p>
                      <span className="highlightedText">US CPI (Tues):</span> was much awaited until the China 90day truce…any blips up will be seen as short term
                    </p>
                  </li>

                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">JPY PPI (Wed):</span> Any pressure for the inputs side of supply. BOJ already downgraded economic outlook
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">OPEC monthly report (Wed):</span> Will they have factored in the China deal improvement on tariffs for end demand?
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">US Retail Sales (Thurs):</span> A critical read on consumer resilience; should be positive with front loading demand high
                    </p>
                  </li>

                  <li className="themesPointer ">
                    <p>
                      <span className="highlightedText">UK and EZ GDP (Thurs): </span> Both Central banks have downgraded growth will it show up here or be ignored now anyway
                    </p>
                  </li>
                  <li className="themesPointer ">
                    <p>
                      <span className="highlightedText">CHF PPI (Thurs):</span> already seeing negative rates at the front end
                    </p>
                  </li>
                  <li className="themesPointer ">
                    <p>
                      <span className="highlightedText">JPY GDP (Fri):</span> will it confirm the BOJ concerns
                    </p>
                  </li>
                  <li className="themesPointer ">
                    <p>
                      <span className="highlightedText">USD Michigan Surveys (Fri):</span> all about whether consumers picked up on the China mood music in the survey period…if not it will in two
                      weeks time…Soft data about to firm up
                    </p>
                  </li>
                </ul>
              </div>

              <div className="relatedImg">
                <img
                  src={image41}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image41)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap ">
              <div className="listImgWrapper">
                <p className="highlightedBoldText">Actionable Takeaway: Trade the Tape, Not the Narrative</p>
                <p>
                  The market looked like it was running on fumes—short vix trades removed anticipating renewed volatility, soft landing hopes but rate cut dreams in tatters post FOMC, PBOC providing
                  liquidity support in abundance and the Fed supporting bond market auctions. Technicals were flashing warnings, and macro risks were resurfacing. BUT the US and China decided enough
                  was enough. Big reverse engine on Facts change:
                </p>
                <ul className="pointersSection">
                  <li className="themesPointer fd_colm">
                    <p>
                      <span className="highlightedText">Equities Forecast:</span> SPX new high for the rally, pro money needs to address downside tail removal, bias is pullbacks will be bought and a
                      risk on period ahead.
                    </p>
                  </li>

                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">FX Setup:</span> Dollar bid short term on capital flows coming back to the US. CPI may reveal tariff fears this week but will be seen as
                      transitory/temporary. Safe-haven flows likely to see unwinds.
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Commodities Watch: </span>Gold and oil seeing geopolitics tension ease and risk on flows ease safe have demand. Inflation may rear its head this
                      week and OPEC + EIA outlooks on Oil may have to factor in the China positives. Oil should retest the supply zone above at least
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Macro Trends to Watch: </span> US inflation trajectory and consumer spending resilience, China demand, central bank policy is liquidity + = risk
                      on. US headlines from the Middle East. International money flow, does it continue back to the US?
                    </p>
                  </li>
                </ul>
              </div>

              <div className="relatedImg">
                <img
                  src={image3}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image3)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1bGGEN24nFX2jvE_nil_0Wk49L3Pfno-rjfkYMBm4KEA/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog17;
